import { gql } from '@apollo/client';

const saveManyMetricValuesMutation = gql`
  mutation SaveManyMetricValues($record: SaveManyMetricValuesInput!) {
    saveManyMetricValues(record: $record) {
      _id
      metricKey
      valueNumber
      valueString
      valueBoolean
      createdAt
    }
  }
`;

export default saveManyMetricValuesMutation;
